import { Component, Input } from '@angular/core';

@Component({
  selector: 'sgt-chat-skeleton',
  templateUrl: './chat-skeleton.component.html',
  styleUrls: ['./chat-skeleton.component.scss']
})
export class ChatSkeletonComponent {
  @Input() turns = 2;

  get skeletonTurns(): number[] {
    return Array(this.turns).fill(0);
  }
}
